export type Language = {
    myCharList: {
        loginTime: string;
    };
    commonBanner: {
        close: string;
        stop_watching: string;
    };
};

export type AllLang = {
    [propName: string]: Language;
};

export const l10nAllLang: AllLang = {
    ko: {
        myCharList: {
            loginTime: '접속',
        },
        commonBanner: {
            stop_watching: '그만보기',
            close: '닫기',
        },
    },
    zh: {
        myCharList: {
            loginTime: '連線',
        },
        commonBanner: {
            stop_watching: '不再顯示',
            close: '關閉',
        },
    },
    ja: {
        myCharList: {
            loginTime: '接続',
        },
        commonBanner: {
            stop_watching: '表示しない',
            close: '閉じる',
        },
    },
    en: {
        myCharList: {
            loginTime: 'Login',
        },
        commonBanner: {
            stop_watching: 'Do not show again.',
            close: 'Close',
        },
    },
    th: {
        myCharList: {
            loginTime: 'เชื่อมต่อ',
        },
        commonBanner: {
            stop_watching: 'ไม่แสดงอีก',
            close: 'ปิด',
        },
    },
    ru: {
        myCharList: {
            loginTime: 'Войти',
        },
        commonBanner: {
            stop_watching: 'Больше не показывать',
            close: 'Закрыть',
        },
    },
    id: {
        myCharList: {
            loginTime: 'Sambungkan',
        },
        commonBanner: {
            stop_watching: 'Jangan tampilkan',
            close: 'Tutup',
        },
    },
    ar: {
        myCharList: {
            loginTime: 'تسجيل الدخول',
        },
        commonBanner: {
            stop_watching: 'لا تظهر مرة أخرى.',
            close: 'أغلق',
        },
    },
};
